<template>
    <div
        class="dropdown is-right action pointer sorting"
        :class="{'is-active': show_dropdown}"
        @mouseleave="show_dropdown = false">

        <div class="dropdown-trigger">
            <i @click="show_dropdown = !show_dropdown" class="fas" :class="icon"></i>
        </div>

        <div class="dropdown-menu">
            <div class="dropdown-content">
                <a @click="select('-created_at')" class="dropdown-item">
                    <i class="icon fas fa-sort-amount-down"></i>
                    Created: Most to least recent
                </a>

                <a @click="select('created_at')" class="dropdown-item">
                    <i class="icon fas fa-sort-amount-up"></i>
                    Created: Least to most recent
                </a>

                <a @click="select('-updated_at')" class="dropdown-item">
                    <i class="icon fas fa-sort-amount-down"></i>
                    Updated: Most to least recent
                </a>

                <a @click="select('updated_at')" class="dropdown-item">
                    <i class="icon fas fa-sort-amount-up"></i>
                    Updated: Least to most recent
                </a>

                <a @click="select('name')" class="dropdown-item">
                    <i class="icon fas fa-sort-alpha-down"></i>
                    Title: A to Z
                </a>

                <a @click="select('-name')" class="dropdown-item">
                    <i class="icon fas fa-sort-alpha-up"></i>
                    Title: Z to A
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NoteListSort',
    data() {
        return { show_dropdown: false };
    },
    computed: {
        icon() {
            const icons = {
                created_at: 'fa-sort-amount-down',
                '-created_at': 'fa-sort-amount-up',
                updated_at: 'fa-sort-amount-down',
                '-updated_at': 'fa-sort-amount-up',
                name: 'fa-sort-alpha-down',
                '-name': 'fa-sort-alpha-up',
            };
            return icons[this.$route.query.sort || '-created_at'];
        },
    },
    methods: {
        select(sort) {
            this.show_dropdown = false;
            this.$emit('select', sort);
        },
    },
};
</script>

<style scoped>
    .sorting .dropdown-item {
        padding-right: 1.5rem;
    }
</style>
